module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kj-La.8705ed1d.png";